import { Status } from '@/common/enums/Status';
import { BagApiResponse } from '@/common/models/response.model';
import { Organization } from '@/reservation/reservation.model';
import { Location, MainPicture, ProductKind, Tag } from '@/promotions/promotions/promotions.component';

export interface BagPaymentTermFilters {
	count_kind: string | null;
	currency__in: Array<number | string>;
	kind: string | null;
	offer_product: Array<number | string>;
	reservation_organization: Array<number | string>;
	reservation_seller: Array<number | string>;
	reservation_status: Status[];
	reservation_stay_time_lower_after: string | null;
	reservation_stay_time_lower_before: string | null;
	reservation_stay_time_upper_after: string | null;
	reservation_stay_time_upper_before: string | null;
	seller_is_oskar: string | null;
	source: string | null;
	status__in: string[];
	table_id__in: string | null;
	table_name__in: string | null;
	term__gte: string | null;
	term__lte: string | null;
	value__gte: number | null;
	value__lt: number | null;
	limit?: number;
	offset?: number;
	ordering?: string | null;
	on?: number;
	[key: string]: unknown;
}

export interface BagPaymentTermListParseFilters {
	term__gte: string | null;
	term__lte: string | null;
}

export interface BagPaymentTermParameters {
	agencies: BagPaymentOrganization[];
	status: BagPaymentTermParametersStatus[];
}

export interface CountKind {
	id: string;
	name: string;
}

export interface BagPaymentTermParametersStatus {
	id: string;
	name: string;
}

export interface ReservationStatus {
	id: string;
	name: string;
}

export interface BagPaymentTermProduct {
	code: string;
	id: number | string;
	location: Location[];
	main_picture: MainPicture;
	name: string;
	nights_stay: number;
	productKind: ProductKind;
	status: string;
	tags: Tag[];
}

export interface BagPaymentTermCurrency {
	code: string;
	exchangeRatePln: number;
	id: number | string;
	name: string;
}

export interface BagPaymentOrganization extends Omit<Organization, 'id'> {
	id: number | string;
}
export type BagCurrenciesResponse = BagApiResponse<BagPaymentTermCurrency>;
export type BagOrganizationsResponse = BagApiResponse<BagPaymentOrganization>;
export type BagAgenciesResponse = BagApiResponse<BagPaymentOrganization>;
export type BagProductsResponse = BagApiResponse<BagPaymentTermProduct>;

export interface BagPaymentTermListTableColumn {
	id: string;
	name: string;
}

export interface BagPaymentTermTableItem {
	accountNumber: string[];
	countValue: number;
	countKind: string;
	currency: number;
	id: number;
	invoiceNumber: string[];
	kind: string;
	ownerName: string;
	refundRecipientName: string | null;
	reservationSeller: number | string;
	source: string;
	status: string;
	tableId: number;
	tableName: string;
	term: string;
	value: number;
	vindicationAgent?: number;
}

export function isBagPaymentTermTableItem(
	item: BagPaymentTermTableItem | BagPaymentTermResponseResultSummary,
): item is BagPaymentTermTableItem {
	return 'id' in item;
}

export interface BagPaymentTermAmountResponse {
	totalAmount: number;
	commissionWithInvoice: number;
	commissionWithoutInvoice: number;
}

export interface BagPaymentTermResponse extends Omit<BagApiResponse, 'results'> {
	results: BagPaymentTermResponseResult;
}
export type BagPaymentTermResponseResult = Array<BagPaymentTermTableItem | BagPaymentTermResponseResultSummary>;

export type BagPaymentTermResponseResultSummary = BagPaymentTermResponseResultSummaryItem;

export interface BagPaymentTermResponseResultSummaryItem {
	amount: number | string;
	balance: number | string;
	currency: string;
	value?: number;
}

export interface FastFilter {
	id: number;
	name: string;
	filters: { [key: string]: unknown };
}
